import React, { useState, useEffect } from "react";

import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { Canvas, useFrame, useLoader } from "@react-three/fiber";

import masalaBoxSTL from "./../assets/masala_box.stl";
import masalaBoxClosedSTL from "./../assets/masala_box_closed.stl";

const AnimatedMasalaBox: React.FC<{
  _xoff: number;
  isConnected: boolean;
  animationSpeed: number;
}> = ({ _xoff, isConnected, animationSpeed }) => {
  const [xoff, setXoff] = useState(_xoff);
  const [yoff, setYoff] = useState(2.6);
  const [rotation, setRotation] = useState(0);
  const [color, setColor] = useState("#CAA358" as string);
  // const [boxType, setBoxType] = useState("open" as string);

  const res2 = useLoader(STLLoader, masalaBoxSTL);
  const res1 = useLoader(STLLoader, masalaBoxClosedSTL);

  useFrame(() => {
    if (isConnected) {
      if (xoff > -31) {
        setXoff((prevXoff) => prevXoff - animationSpeed);
      }
      if (Math.trunc(xoff) <= 1 && color === "#CAA358") {
        setColor("green");
      }
      // if (xoff <= -0.5 && boxType === "open") {
      //   setBoxType("closed");
      // }
      if (xoff < -29 && xoff >= -31) {
        setRotation(1.6);
        setYoff(2.6);
      }
      if (xoff <= -31 && yoff > -2) {
        setYoff((prevYoff) => prevYoff - animationSpeed);
      }
      if (xoff <= -31 && yoff <= -2) {
        setXoff(18);
        setYoff(2.6);
        setRotation(0);
        setColor("#CAA358");
        // setBoxType("open");
      }
    }
  });

  return (
    <mesh
      scale={[0.03, 0.02, 0.015]}
      position={[xoff, yoff, -7]}
      rotation={[1.55, rotation, 3.14]}
      visible={true}
    >
      <primitive
        // object={boxType === "open" ? res1 : res2}
        object={res1}
      />
      <meshStandardMaterial color={color} />
    </mesh>
  );
};

const AnimationMasalaBoxContainer: React.FC<{
  isConnected: boolean;
  animationSpeed: number;
}> = ({ isConnected, animationSpeed }) => {
  const numBoxes = 15;
  const initialXOffset = 15;
  const boxSpacing = 5;

  return (
    <>
      {[...Array(numBoxes)].map((_, i) => (
        <AnimatedMasalaBox
          key={i}
          _xoff={initialXOffset + i * boxSpacing}
          isConnected={isConnected}
          animationSpeed={animationSpeed}
        />
      ))}
    </>
  );
};

export default AnimationMasalaBoxContainer;
